export default __webpack_public_path__ + "static/media/frame_zh_tw_pc.28363b6d.png";